export const ROUTE_AREA_EXPORT_ID = 'route-area';

export const ROUTE_AREA_TITLE = 'Áreas de Rutas';

export const LOCALIZED_PROPERTIES = {
  name: 'Nombre',
  company: 'Compañia',
  statusId: 'Estado',
};
